let {Card} = require('./card');

export class Hand {
    constructor(cards) {
        if (!Array.isArray(cards)) {
            throw Error('Cards must be Array');
        }
        if (cards.length < 2) {
            throw Error('Hand must have more than two cards')
        }
        cards.forEach(function(card) {
            if (!(card instanceof Card)) {
                throw Error('Hand array elements must be Card object');
            }
        });
        this.cards = cards;
    }
}